<template>
  <svg
    :class="svgClass"
    :style="{ width: width, height: height }"
    aria-hidden="true"
  >
    <use :xlink:href="`#icon-${this.iconName}`"></use>
  </svg>
</template>

<script>
export default {
  name: 'icon-svg',
  props: {
    iconName: {
      type: String,
      required: true
    },
    iconClass: {
      type: String
    },
    width: {
      type: String
    },
    height: {
      type: String
    }
  },
  computed: {
    svgClass() {
      if (this.iconClass) {
        return 'svg-icon ' + this.iconClass
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/*此处为所有图标默认显示样式*/
.svg-icon {
  width: 16px;
  height: 16px;
  vertical-align: -3px;
  fill: currentColor;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue